export const TIER_LABEL = {
  unverified: "Unverified",
  email: "Email verified",
  phone: "Phone verified",
  license: "Licensed Professional — Verified",
  gov_id: "ID verified",
};

export const TIER_SHORT = {
  unverified: "Unverified",
  email: "Email verified",
  phone: "Phone verified",
  license: "Licensed Pro",
  gov_id: "ID verified",
};

export function tierBadgeClass(t) {
  if (t === "license") return "bg-[#1B4D3E] text-white border-[#1B4D3E]";
  if (t === "phone") return "bg-[#E6F0EB] text-[#2E6B4F] border-[#2E6B4F]/30";
  if (t === "email") return "bg-[#E6F0EB] text-[#2E6B4F] border-[#2E6B4F]/30";
  if (t === "gov_id") return "bg-[#EDEBF5] text-[#4B4E8C] border-[#4B4E8C]/30";
  return "bg-[#F0EBE1] text-[#8A877F] border-[#DEDBD3]";
}
